import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  getProposalDetails,
  getBilletProposal,
  getLinhaDigitavelProposalBillet,
} from './actions';
import api from '../../services/api';

function* getProposalDetailsSaga() {
  try {
    const creditorId = 3265006;
    const proposalType = 1;
    const proposalId = 0;
    const proposals = yield call(api.getProposalDetails, {
      creditorId,
      proposalType,
      proposalId,
    });
    yield put(getProposalDetails.success(proposals));
  } catch {
    yield put(getProposalDetails.failure('Falha ao buscar propostas.'));
  }
}

function* getBilletProposalSaga(
  action: ReturnType<typeof getBilletProposal.request>
) {
  try {
    const cpf = yield select((state: ApplicationState) => state.auth.cpf);
    const billet = yield call(api.getBilletProposal, {
      planId: action.payload.planId,
      proposalId: action.payload.proposalId,
      databaseId: action.payload.databaseId,
    });
    yield put(getBilletProposal.success(billet));

    if (billet)
      action.payload.callBack({
        linhaDigitavel: billet,
        nnumero: '',
        doc: action.payload.type,
      });
  } catch {
    yield put(getBilletProposal.failure('Falha ao obter boleto.'));
  }
}

function* getLinhaDigitavelProposalBilletSaga(
  action: ReturnType<typeof getLinhaDigitavelProposalBillet.request>
) {
  try {
    const cpf = yield select((state: ApplicationState) => state.auth.cpf);
    const billet = yield call(api.getLinhaDigitavelProposalBillet, {
      option: {
        plan: action.payload.planId,
        proposalId: action.payload.proposalId,
        sendType: action.payload.sendType,
      },
    } as any);
    yield put(getLinhaDigitavelProposalBillet.success(billet));

    if (billet && billet.linhaDigitavel)
      action.payload.callBack(action.payload.sendType, billet);
  } catch {
    yield put(
      getLinhaDigitavelProposalBillet.failure('Falha ao obter boleto.')
    );
  }
}

export default all([
  takeLatest(getProposalDetails.request, getProposalDetailsSaga),
  takeLatest(getBilletProposal.request, getBilletProposalSaga),
  takeLatest(
    getLinhaDigitavelProposalBillet.request,
    getLinhaDigitavelProposalBilletSaga
  ),
]);
